import React from "react";

export const WalletTransactionCashOut = ({ wallet }) => {
  return (
    <>
      {wallet.cc_type === 'TRX-TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t' && Number(wallet.ref_type) === 4 ?
        <a className="hover:bg-gray-400 mr-1 text-xs" href={`https://tronscan.org/#/address/${wallet.payment_address}/transfers`} target="_blank" rel="noreferrer">{wallet.payment_address}</a> : ''}

      {wallet.cc_type === 'USDT' && Number(wallet.ref_type) === 4 ?
        <a className="hover:bg-gray-400 mr-1 text-xs" href={`https://usdt.tokenview.io/en/address/${wallet.cc_address}`} target="_blank" rel="noreferrer">{wallet.cc_address}</a> : ''}

      {wallet.cc_type === 'USDT-TRC20' && Number(wallet.ref_type) === 4 ?
        <a className="hover:bg-gray-400 mr-1 text-xs" href={`https://tronscan.org/#/transaction/${wallet.txid}`} target="_blank" rel="noreferrer">{wallet.txid}</a> : ''}

      {Number(wallet.ref_type) === 1 ? <a className="hover:bg-gray-400 mr-1 text-xs" href={`https://usdt.tokenview.io/en/address/${wallet.cc_address}`} target="_blank" rel="noreferrer">{wallet.cc_address}</a> : ''}
    </>
  );
};
